import React from "react";
import { Icon } from "@iconify/react";


export const CollaboratorsToggle = ({ onPressed = () => { } }) => {
  return (<button className="lk-button"
    onClick={() => {
      onPressed();
    }}
    style={{ marginRight: "8px" }}
  >
    <Icon icon="mdi:account-multiple" width="20" height="20" />
  </button>);
}

export default CollaboratorsToggle;
